import { HttpEventType } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { SimplifiedStudy } from 'src/app/data/study';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';
import { ConfigService } from 'src/app/services/config.service';
import { StudiesService } from 'src/app/services/studies.service';
import { environment } from 'src/environments/environment';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';

@Component({
  selector: 'app-study-historic-modal',
  templateUrl: './study-historic-modal.component.html',
  styleUrls: ['./study-historic-modal.component.css']
})
export class StudyHistoricModalComponent {

  @ViewChild(ReportViewerComponent) reportViewerComponent!: ReportViewerComponent;

  opened = false;
  displayedColumns: string[] = ['StudyDate', 'StudyDescription', 'Status', 'Actions'];

  downloading: { studyUID: string | null, percentage: number } | null = null;
  pollingInterval: any = null;

  studyMasterUID: string | null = null;
  patientName: string | null = null;
  historicStudyList: SimplifiedStudy[] = [];

  refreshing = false;
  lastRefresh = 0;
  refreshInterval: any = null;

  constructor(
    private alertService: AlertService,
    private bookService: BookService,
    private configService: ConfigService,
    private studyService: StudiesService
  ) { }

  close() {
    this.opened = false;
    this.historicStudyList = [];
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  get isEmpty(): boolean {
    return !this.historicStudyList || this.historicStudyList.length === 0;
  }

  open(studyUID: string, patientName: string) {
    this.studyMasterUID = studyUID;
    this.patientName = patientName;
    this.opened = true;

    //Carga de datos inmediata
    this.refreshData();
    
    //Carga de datos periódica
    this.refreshInterval = setInterval(() => {
      if (this.lastRefresh + 1000 < new Date().getTime()) {
        this.refreshData();
      }
    }, 5000);

  }

  refreshData() {
    if (!this.refreshing) {
      this.refreshing = true;
      Promise.all([this.refreshHistoricStudies()]).then(res => {
        this.lastRefresh = new Date().getTime();
        this.refreshing = false;
      }).catch(error => this.refreshing = false);
    }
  }

  refreshHistoricStudies(): Promise<void | SimplifiedStudy[]> {
    return this.getHistoricStudies().then(historicStudies => {
      this.historicStudyList = historicStudies;
    }
    ).catch(error => {
      console.error('Error fetching historic studies:', error);
    });
  }

  getHistoricStudies(): Promise<SimplifiedStudy[]> {
  
    return new Promise((resolve, reject) => {
      if(this.studyMasterUID != null && this.studyMasterUID != ""){
        // Se refiere al id de User pero el UserId del Prescriber del Generador de Books
        this.studyService.getOtherPatientStudies(this.studyMasterUID).then(historicStudies => {
          console.log('HistoricStudy list', historicStudies);
          resolve(historicStudies);
        })
      }else{
        reject('No study master UID provided');
      }
    })
    
  }

  onClickObtainStudy(study: SimplifiedStudy) {
    if (!study.studyUID) return;

    this.studyService.obtainStudy(study.studyUID).then(() => {
      // La recarga automática de estudios de histórico se encarga de actualizar el estado
    }).catch(e => {
      console.error(e);
    });
  }

  onClickSeeBook(study: SimplifiedStudy) {
    if (study.studyUID != null && study.studyUID != "") {
      this.bookService.checkAccessWithStudyUID(study.studyUID).then(res => {
        if (res != null) {
          const protocol = location.protocol + '//';
          const hostname = location.hostname;
          const route = `${protocol + hostname}/books/acceso?tkn=${res.token}&acctk=${res.accessionToken}`;
          window.open(route);
        } else {
          this.alertService.alert('No se ha podido abrir el book. Por favor, póngase en contacto con su centro');
        }
      }).catch(e => {
        console.error(e);
        this.alertService.alert('Ha habido un error abriendo el book. Por favor, póngase en contacto con su centro');
      });
    }
  }

  async onClickOpenVisor(study: SimplifiedStudy) {
    if (study.studyUID == null || study.studyUID == '') {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }

    try {
      this.bookService.getTokenByStudyUID(study.studyUID).then(tkn => {
        try{
          this.configService.getConfig().then(c => {
            const route = c.visorRoute + `?sid=${study.studyUID}&ustkn=${tkn}`;
            console.log('route; ', route);
            let visorWindow = window.open(route, 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
          })
        }catch(error){
          console.error('Error obteniendo token de accesp:', error);
          this.alertService.alert('Error al obtener el token de acceso');
        }
      });
    } catch (error) {
      console.error('Error obteniendo token del estudio: '+study.studyUID, error);
      this.alertService.alert('Error al obtener el token del estudio'+study.studyUID);
    }
  }

  onClickDownloadStudy(study: SimplifiedStudy) {
    if (study.studyUID == null) {
      this.alertService.alert('Error al descargar el estudio. Por favor, inténtelo de nuevo más tarde.');
      console.error("StudyUIDs is null");
      return;
    }

    if (this.downloading == null) {
      this.downloading = { studyUID: study.studyUID, percentage: 0 };
      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            if (++this.downloading!.percentage == 100) {
              clearInterval(interval);
              this.downloading = null;
            }
          }, 75);
        } else {
          let startedDownloading = false;
          const randomIntFromInterval = (min: number, max: number) => {
            return Math.floor(Math.random() * (max - min + 1) + min);
          };
          const interval = setInterval(() => {
            if (startedDownloading) {
              clearInterval(interval);
            } else {
              if (this.downloading!.percentage < 10) {
                this.downloading!.percentage += (randomIntFromInterval(0, 30) / 100);
              } else if (this.downloading!.percentage < 20) {
                this.downloading!.percentage += (randomIntFromInterval(10, 30) / 100);
              } else if (this.downloading!.percentage < 30) {
                this.downloading!.percentage += (randomIntFromInterval(10, 50) / 100);
              } else if (this.downloading!.percentage < 35) {
                this.downloading!.percentage += (randomIntFromInterval(0, 10) / 100);
              } else if (this.downloading!.percentage < 50) {
                this.downloading!.percentage += (randomIntFromInterval(0, 7) / 100);
              }
            }
          }, 1200);
          this.studyService.downloadStudies([study.studyUID!]).subscribe(event => {
            if (event!.type == HttpEventType.DownloadProgress) {
              startedDownloading = true;
              const percentage = ((event!.loaded / event!.total!) * 50) + 50;
              console.log('percentage: ', percentage);
              this.downloading!.percentage = Math.round(percentage);
            }
            if (event!.type == HttpEventType.Response) {
              const link = document.createElement('a');
              if (link.download !== undefined) {
                const url = URL.createObjectURL(event!.body!);
                link.setAttribute('href', url);
                link.setAttribute('download', "dicomdir.zip");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              this.downloading = null;
            }
          }, error => {
            console.error('Error downloading study:', error);
            this.alertService.alert('Error al descargar el estudio. Por favor, inténtelo de nuevo más tarde.');
            this.downloading = null;
          });
        }
      }, 1);
    } else {
      this.alertService.alert('Ya se está descargando un estudio. Por favor, espere a que finalice');
    }
  }

  onClickDownloadReport(study: SimplifiedStudy) {
    if (study.studyUID != null) {
      this.studyService.downloadReport([study.studyUID]);
    } else {
      console.error("StudyUIDs is null");
    }
  }

  isStudyDeleted(study: SimplifiedStudy): boolean {
    return study.studyStatus === 'DELETED';
  }

  isStudyReady(study: SimplifiedStudy): boolean {
    return study.studyStatus === 'READY' || !study.studyStatus;
  }

  isStudyObtaining(study: SimplifiedStudy): boolean {
    return study.studyUID ? this.studyService.isObtaining(study.studyUID) : false;
  }

  onClickOpenReportPreview(study: SimplifiedStudy) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();
    
    if(study.studyUID != null && study.studyUID != ""){
      this.reportViewerComponent?.showByStudyUID(study.studyUID);
    } else {
      console.error('StudyUID is null or empty');
      this.alertService.alert('No se puede mostrar el informe. StudyUID no disponible.');
    }
  }

}
